import { gql } from '@apollo/client';

export const MUTATION_UPDATE_NOTIFICATION_READ_STATUS = gql`
  mutation ($input: UpdateBatchNotificationsReadStatusInput) {
    updateBatchNotificationsReadStatus(input: $input)
  }
`;
